export const ANNOUNCEMENTS = `
	query announcements($event_id: Uint, $offset: Uint, $items_per_page: Uint) {
		announcements(event_id: $event_id, offset: $offset, items_per_page: $items_per_page) {
			nodes {
				id
				name
				body
				link
				send_at
				sent
				pinned
				open_rate
				groups {
					id
					name
				}
				updated_at
				created_at
			}
			page_info {
				has_next_page
				total_count
			}
		}
	}
`;
